export type ContentfulEntryNotResolvableError = {
  sys: {
    id: 'notResolvable';
    type: 'error';
  };
  details: {
    type: 'Link';
    linkType: string;
    id: string;
  };
};

export function isEntryResolveError(
  value: unknown
): value is ContentfulEntryNotResolvableError {
  return Boolean(
    value &&
    typeof value === 'object' &&
    'sys' in value &&
    value.sys &&
    typeof value.sys === 'object' &&
    'id' in value.sys &&
    value.sys.id === 'notResolvable' &&
    'type' in value.sys &&
    value.sys.type === 'error' &&
    'details' in value &&
    value.details &&
    typeof value.details === 'object' &&
    'type' in value.details &&
    value.details.type === 'Link' &&
    'id' in value.details &&
    typeof value.details.id === 'string' &&
    'linkType' in value.details &&
    typeof value.details.linkType === 'string'
  );
}
